import ClubSideBarView from "./ClubSideBarView";

export const ClubSideBar = function() {

    return (
        <ClubSideBarView/>
    )
}
